import React, { Component } from 'react';
import { connect } from 'react-redux';
import CanDisplay from '../../CanDisplay';
import './EditCustomerSubMenu.scss';

class EditCustomerSubMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayModal: false,
    };
  }

  render() {
    const remainder = this.props.customerData.index % this.props.tablePageSize;
    return (
      <div>
        <div
          className="editCustomerSubMenu"
          style={{
            top:
              this.props.tablePage === 0 &&
              this.props.customerData.index < this.props.tablePageSize
                ? `calc(70px + 37px* ${this.props.customerData.index})`
                : `calc(70px + 37px* ${remainder})`,
          }}
        >
          <CanDisplay
            rules={this.props.rules}
            perform="edit_customers"
            yes={() => (
              <button
                id="editCustomerBtn"
                onClick={() => {
                  this.props.openEditCustomerModal();
                }}
              >
                Edit Customer
              </button>
            )}
          />
          <button
            id="deleteCustomerBtn"
            onClick={() => {
              this.props.openDeleteCustomerModal();
            }}
          >
            Delete
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, rules }) => {
  return {
    auth,
    rules,
  };
};

export default connect(mapStateToProps, {})(EditCustomerSubMenu);
